import { Check } from "lucide-react";
import { Reveal } from "./motion";
import { MANIFESTO, IMAGES, BUSINESS } from "@/data/siteData";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <Reveal>
          <div className="relative rounded-[1.6rem] overflow-hidden shadow-[0_24px_50px_rgba(10,37,145,0.14)] border border-white">
            <img src={IMAGES.verify} alt="California licensed verifier confirming a vehicle VIN on the door jamb" className="w-full h-[360px] lg:h-[460px] object-cover" loading="lazy" />
          </div>
        </Reveal>

        <div>
          <Reveal>
            <p className="text-brand font-semibold text-sm tracking-wide uppercase">About Us</p>
            <h2 className="font-display font-bold text-ink tracking-tight text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.1]">
              The verifier California trusts
            </h2>
            <p className="text-slate2 text-base sm:text-lg mt-4 leading-relaxed">
              {BUSINESS.name} was founded by {BUSINESS.owner}, a California state-licensed vehicle
              verifier, on a simple idea: getting your vehicle verified shouldn't mean lost hours in
              a DMV line. We bring the licensed expertise to you.
            </p>
          </Reveal>

          <div className="mt-8 space-y-5">
            {MANIFESTO.map((m, i) => (
              <Reveal key={m.n} delay={i * 0.08}>
                <div data-testid={`about-point-${m.n}`} className="flex gap-4">
                  <span className="h-9 w-9 shrink-0 rounded-full bg-brand/10 text-brand flex items-center justify-center">
                    <Check size={18} />
                  </span>
                  <div>
                    <h3 className="font-display font-semibold text-ink text-lg">{m.title}</h3>
                    <p className="text-slate2 text-sm mt-1 leading-relaxed">{m.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-mist border border-gray-100 px-4 py-2 text-sm text-ink font-medium">
              <span className="h-2 w-2 rounded-full bg-brand" /> {BUSINESS.license}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
